import { useEffect, useRef, useState } from "react";
import { ExternalLink, MapPin } from "lucide-react";

const label = (p) => {
  const city = p.city || p.town || p.village;
  return [[p.street, p.housenumber].filter(Boolean).join(" ") || p.name, [p.postcode, city].filter(Boolean).join(" "), p.county !== city && p.county].filter(Boolean).join(", ");
};
const gmaps = (a) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(a)}`;

const useSuggest = (q, active) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!active || q.trim().length < 4) { setList([]); return undefined; }
    const ctl = new AbortController();
    const t = setTimeout(() => {
      fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(q)}&limit=5&lat=45.07&lon=7.68&bbox=6.6,36.6,18.6,47.1`, { signal: ctl.signal })
        .then((r) => r.json()).then((d) => setList([...new Set(d.features.map((f) => label(f.properties)).filter(Boolean))])).catch(() => {});
    }, 350);
    return () => { clearTimeout(t); ctl.abort(); };
  }, [q, active]);
  return [list, setList];
};

export const AddressInput = ({ value, onChange, testid = "address", placeholder = "Via, numero civico, città", className = "rp-field", map = true }) => {
  const [focus, setFocus] = useState(false);
  const [typed, setTyped] = useState(false);
  const [list, setList] = useSuggest(value || "", focus && typed);
  const box = useRef(null);
  const pick = (a) => { onChange(a); setList([]); setTyped(false); };
  return (
    <div className="space-y-2" ref={box}>
      <div className="relative">
        <input value={value || ""} onChange={(e) => { onChange(e.target.value); setTyped(true); }} onFocus={() => setFocus(true)} onBlur={() => setTimeout(() => setFocus(false), 200)}
          className={className} placeholder={placeholder} autoComplete="off" data-testid={`${testid}-input`} />
        {list.length > 0 && focus && (
          <div className="absolute z-50 left-0 right-0 mt-1 rounded-2xl bg-white border border-[#EBEBEB] shadow-lg overflow-hidden" data-testid={`${testid}-suggestions`}>
            {list.map((a, i) => (
              <button type="button" key={a} onMouseDown={(e) => { e.preventDefault(); pick(a); }} className="w-full text-left px-4 py-2.5 text-sm hover:bg-[#F7F7F7] flex items-center gap-2" data-testid={`${testid}-suggestion-${i}`}>
                <MapPin className="h-4 w-4 text-[#757575] shrink-0" /> {a}
              </button>
            ))}
          </div>
        )}
      </div>
      {map && (value || "").trim().length > 5 && !typed && (
        <div className="rounded-2xl overflow-hidden border border-[#EBEBEB]" data-testid={`${testid}-map`}>
          <iframe title="Mappa" src={`https://maps.google.com/maps?q=${encodeURIComponent(value)}&z=16&output=embed`} className="w-full h-40 border-0" loading="lazy" />
          <a href={gmaps(value)} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 py-2 text-sm font-medium bg-white hover:bg-[#F7F7F7]" data-testid={`${testid}-open-maps`}>
            <ExternalLink className="h-4 w-4" /> Apri in Google Maps
          </a>
        </div>
      )}
      {map && typed && (value || "").trim().length > 5 && (
        <button type="button" onClick={() => setTyped(false)} className="text-xs underline text-[#757575]" data-testid={`${testid}-verify`}>Verifica sulla mappa</button>
      )}
    </div>
  );
};
